import React from 'react';
import { useInterfaceLanguage } from '../hooks/useInterfaceLanguage';
import { InterfaceLanguageCode } from '../constants/interfaceLanguages';

import { EmojiText } from './common/Picto';
interface InterfaceLanguageSelectorProps {
  className?: string;
}

const InterfaceLanguageSelector: React.FC<InterfaceLanguageSelectorProps> = ({ className = '' }) => {
  const { language, setLanguage, availableLanguages } = useInterfaceLanguage();

  return (
    <select
      className={`profile-language-select ${className}`}
      value={language}
      onChange={(e) => setLanguage(e.target.value as InterfaceLanguageCode)}
      aria-label="Interface language"
    >
      {availableLanguages.map((lang) => (
        <option key={lang.code} value={lang.code}>
          <EmojiText text={lang.flag} /> {lang.nativeName}
        </option>
      ))}
    </select>
  );
};

export default InterfaceLanguageSelector;
